import React from 'react';
import { ToggleBtnContainer, ToggleSlide, StyledIcon } from './styled.js';

const FolderToggle = ({ toggled, type }) => (
  <React.Fragment>
    <StyledIcon toggled={toggled} type={type} icon={`${type}Folder`} width="100%" height="100%" />
    <StyledIcon toggled={toggled} type={type} icon={`${type}Spread`} width="100%" height="100%" />
    <ToggleSlide toggled={toggled} type={type} />
  </React.Fragment>
);

const CompareToggle = ({ toggled, type }) => (
  <ToggleSlide toggled={toggled} type={type}>
    <StyledIcon toggled={toggled} icon="compare" width="100%" height="100%" />
  </ToggleSlide>
);

const toggleTypes = {
  compare: CompareToggle,
  layout: FolderToggle,
};

const SlideToggle = ({ type = 'compare', toggled, toggleHandler }) => {
  const Component = toggleTypes[type];
  return (
    <ToggleBtnContainer onClick={toggleHandler} toggled={toggled} type={type}>
      <Component toggled={toggled} type={type} />
    </ToggleBtnContainer>
  );
};

export default SlideToggle;
